import React, { useMemo } from 'react'

import clsx from 'clsx'

import { TableCell, Txt } from 'src/components/atoms'
import { DateTxt } from 'src/components/molecules'
import { LineLimitTxtWithTooltip } from 'src/components/molecules/texts/LineLimitTxtWithTooltip'

import { useGetUsers } from 'src/hooks'
import { useGetCompassRoles } from 'src/hooks/useGetCompassRoles'
import { ProfileEntity, ProjectAssignUserEntity } from 'src/types'

type Props = {
  profile?: ProfileEntity
  internalUser: ProjectAssignUserEntity
  className?: string
}

export function InternalAssignUserTableRow({ profile, internalUser, className }: Props) {
  const { compassRoles } = useGetCompassRoles()
  const { users } = useGetUsers()

  const compassRole = useMemo(() => {
    return compassRoles.find(role => role.id === internalUser.compassRole.id)
  }, [internalUser, compassRoles])

  const targetUser = useMemo(() => {
    return users.find(user => user.id === internalUser.id)
  }, [internalUser.id, users])

  return (
    <div className={className}>
      <div className="tw-flex tw-gap-s0 tw-px-s0 tw-text-standardText-secondary tw-h-[4.3rem]">
        <TableCell className="tw-w-full tw-shrink">
          <LineLimitTxtWithTooltip
            className={clsx(
              'tw-break-all',
              internalUser.id === profile?.id
                ? 'tw-text-pattern6-3'
                : 'tw-text-standardText-primary'
            )}
            text={internalUser.name ?? '-'}
            lineLimit={2}
          />
        </TableCell>
        <TableCell width={16}>
          <LineLimitTxtWithTooltip
            className="tw-break-all"
            text={internalUser.email}
            lineLimit={2}
          />
        </TableCell>
        <TableCell width={16}>
          <LineLimitTxtWithTooltip
            className="tw-break-all"
            text={
              targetUser?.keywords && targetUser.keywords.length > 0
                ? targetUser.keywords.join(',')
                : '-'
            }
            lineLimit={2}
          />
        </TableCell>
        <TableCell width={16}>
          <LineLimitTxtWithTooltip
            className="tw-break-all"
            text={
              targetUser?.customRoles && targetUser.customRoles.length > 0
                ? targetUser.customRoles.map(role => role.name).join(',')
                : '-'
            }
            lineLimit={2}
          />
        </TableCell>
        <TableCell width={16}>
          <DateTxt date={internalUser.assignedAt} />
        </TableCell>
        <TableCell width={16}>
          <Txt>{compassRole?.displayName}</Txt>
        </TableCell>
      </div>
    </div>
  )
}
